<div class="sb-step sb-step-winback">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <img src="/assets/images/promo-coupon.svg" class="coupon_badge" alt="Promo coupon">
        <div class="sb-form-block ticket" formGroupName="couponInfo">
          <div class="ticket__left">
            <img src="/assets/images/promo-coupon.svg" alt="Promo coupon">
          </div>
          <div class="ticket__right">
            <div class="sb-form-block__title ticket__title wt-text-align-left ">
              {{'ENTITY.COUPON.TITLE' | translate}}
            </div>
            <div class="ticket__field">
              <div class="row wt-margin-bottom-4 wt-t">
                <div class="col-xs-12">
                  <wt-input-text [validateOnBlur]="true"
                                 additionalClass="sb-transform-uppercase"
                                 [maxLength]="FormConstants.MAXIMUM_COUPON_LENGTH" [label]="'ENTITY.COUPON.PLACEHOLDER' | translate"
                                 formControlName="code"></wt-input-text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>

